import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashFlowinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.28,
			d: "M9.792 5.833v1.042M9.792 14.167v-1.042M11.864 8.333a1.56 1.56 0 0 0-1.552-1.458H9.171a1.462 1.462 0 0 0-.356 2.882l1.952.49a1.463 1.463 0 0 1-.355 2.881H9.27c-.828 0-1.5-.646-1.553-1.461"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "M4.892 4.893a7.2 7.2 0 0 1 5.11-2.115A7.225 7.225 0 0 1 17.228 10c0 .557-.069 1.097-.188 1.617"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "m15.923 10.502 1.305 1.305 1.306-1.305M15.108 15.107a7.2 7.2 0 0 1-5.11 2.115A7.225 7.225 0 0 1 2.772 10c0-.557.069-1.097.188-1.617"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "M4.077 9.498 2.772 8.193 1.466 9.498"
		})
	]
});
export default SvgCashFlowinline;
